export function getMediaUrl(src) {
    if (!src) return null;

    const trimmed = src.trim();

    // Case 1: already absolute (Spaces, S3, CDN)
    if (/^https?:\/\//.test(trimmed)) return trimmed;

    // Case 2: normalize protocol-relative or malformed paths
    const normalized = trimmed.replace(/^\/+/, '/');

    // Case 3: prepend base
    const mediaBase =
        process.env.REACT_APP_MEDIA_BASE ||
        (process.env.REACT_APP_API_ENDPOINT || 'http://127.0.0.1:8000/api').replace(/\/api\/?$/, '');

    return `${mediaBase}${normalized}`;
}